import { Component, EventEmitter, Output } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ButtonLoaderComponent } from '../../../../shared/components/button-loader/button-loader.component';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { InputWrapperComponent } from '../../../../shared/components/input-wrapper/input-wrapper.component';
import { UserService } from '../../../../shared/services/user.service';
import { SharedModule } from '../../../../shared/shared.module';

@Component({
  selector: 'app-change-password',
  standalone: true,
  imports: [
    SharedModule,
    InputWrapperComponent,
    ButtonComponent,
    ButtonLoaderComponent,
  ],
  templateUrl: './change-password.component.html',
  styleUrl: './change-password.component.scss',
})
export class ChangePasswordComponent {
  @Output() close = new EventEmitter();
  changePasswordForm: FormGroup = this.fb.group({
    oldPassword: ['', [Validators.required]],
    newPassword: ['', [Validators.required, Validators.minLength(8)]],
    confirmPassword: [
      '',
      [Validators.required, this.matchValue('newPassword')],
    ],
  });
  isLoading = false;
  showConfirmPassword = false;
  showNewPassword = false;
  showOldPassword = false;
  constructor(
    private fb: FormBuilder,
    private userService: UserService,
    private toastr: ToastrService
  ) {}
  onSubmit() {
    if (this.changePasswordForm.invalid) {
      this.changePasswordForm.markAllAsTouched();
      return;
    }
    const { oldPassword, newPassword } = this.changePasswordForm.value;
    this.isLoading = true;
    this.userService.changePassword({ oldPassword, newPassword }).subscribe({
      next: () => {
        this.isLoading = false;
        this.handleClose();
        this.toastr.success('Password changed successfully');
      },
      error: (err) => {
        this.isLoading = false;
        this.toastr.error(
          err?.error?.message || err?.message || 'Something went wrong!'
        );
      },
    });
  }

  handleClose() {
    this.close.emit();
  }

  matchValue(controlName: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      return control.value !==
        (control.parent?.controls as any)?.[controlName]?.value
        ? { valueMatchErr: true }
        : null;
    };
  }
}
